import React from 'react';
import { ActionBase } from '../ActionBase';
import { Store } from '../Store';
import { copyObject } from 'common/copyObject';

export type RedirectLoginData = {
	client_id: string;
	redirect_uri?: string;
};

export const initialRedirectLoginData: RedirectLoginData = {
	client_id: undefined,
};

//////////////////////////////////////////////////
// SaveAction
//////////////////////////////////////////////////
// Action
class SaveAction extends ActionBase {
	redirectLoginData: RedirectLoginData;
}
// Action name
const SaveActionName = SaveAction.toString();

// Action generator
export const saveGenerator = async (dispatch: React.Dispatch<ActionBase>, redirectLoginData: RedirectLoginData) => {
	const action = {
		action: SaveActionName,
		redirectLoginData,
	} as SaveAction;

	dispatch(action);
};

// Reducer
const saveReducer = (state: Store, action: ActionBase): Store => {
	const thisAction = action as SaveAction;
	const newState: Store = copyObject(state);
	newState.redirectLoginData = thisAction.redirectLoginData;
	return newState;
};

////////////////////////////////////////////////////////////////////////////////
// Reduce functions finder
////////////////////////////////////////////////////////////////////////////////
export const RedirectLoginReduceFunction = (state: Store, action: ActionBase): Store => {
	switch (action.action) {
		case SaveActionName:
			return saveReducer(state, action);
	}
	return null;
};
